import React from 'react';
import { publicProspectPageConfig } from '../../config/publicProspectPageConfig';
import { formatPublicProspectAddress } from './publicProspectMapUrl';

export default function PublicProspectConfirmation({
  language,
  property,
  intent,
  onContinue,
}) {
  const confirmation = publicProspectPageConfig.confirmation[language] || publicProspectPageConfig.confirmation.fr;
  const formCopy = intent
    ? publicProspectPageConfig.forms[intent]?.[language] || publicProspectPageConfig.forms[intent]?.fr
    : null;
  return (
    <section className="space-y-4 text-center" aria-live="polite">
      <h2 className="prospect-display text-[2rem] font-semibold leading-[1.08] tracking-tight text-[#0B1F2A]">
        {confirmation.title}
      </h2>
      <p className="text-[#1f4a52]">{confirmation.body}</p>
      {formCopy?.heading ? <p className="text-sm font-medium text-[#004747]">{formCopy.heading}</p> : null}
      {property ? (
        <div className="rounded-xl bg-[#eef6f7] p-4 text-[#1f4a52]">
          <p className="font-semibold">{property.address}</p>
          <p>{formatPublicProspectAddress(property)}</p>
        </div>
      ) : null}
      <button
        type="button"
        onClick={onContinue}
        className="prospect-ui inline-flex rounded-xl border border-[#004747] px-5 py-3 text-[1.0625rem] font-bold text-[#004747] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#007c91]"
      >
        {confirmation.continue}
      </button>
    </section>
  );
}
